import React, { memo } from "react";
import { Steps } from "antd";
import { EnvironmentOutlined } from "@ant-design/icons";

export default memo(function PickupDropOffSteps({
  pickupAddress,
  dropOffAddress,
}) {
  return (
    <Steps
      style={{
        marginBottom: 32,
      }}
    >
      <Steps.Step
        title="Pickup"
        description={pickupAddress?.address}
        icon={<EnvironmentOutlined style={{ color: "#4888FA" }} />}
        status="finish"
      />
      <Steps.Step
        title="Drop off"
        description={dropOffAddress?.address}
        icon={<EnvironmentOutlined style={{ color: "#DD4B3E" }} />}
        status="finish"
      />
    </Steps>
  );
});
